import React from "react";
import KYCTable from "../../components/KycTable";
import Sidebar from "../../components/Sidebar";

function KYCPage() {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      {/* Sidebar handles its own desktop/mobile rendering */}
      <Sidebar />

      {/* Main content — scrolls independently */}
      <div className="overflow-y-auto flex-1 p-4 md:py-7">
        <KYCTable />
      </div>
    </div>
  );
}

export default KYCPage;
